import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react'

export default function SsoCallback() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <AuthenticateWithRedirectCallback 
          signInFallbackRedirectUrl="/onboarding"
          signUpFallbackRedirectUrl="/onboarding"
        />
      </div>
    </div>
  )
}

